import { OrderListSearchConfig } from 'src/distribution_platforms/features/order_list';
import { OrderStatus } from 'src/types';
import { OrderStatusFilterOption } from 'src/types/status_filter';

/** Search field UI for SaMD order lists. */
export const samdOrderListSearchConfig: OrderListSearchConfig = {
  placeholder: 'Search orders by Order ID and Patient ID...',
  width: '380px',
};

export enum SamdStatusFilterValue {
  ALL_ORDERS = 'all_orders',
  REPORT_READY = 'report_ready',
  PROCESSING = 'processing',
  PENDING_ACTIONS = 'pending_actions',
  DRAFTS = 'drafts',
}

export const SAMD_STATUS_FILTER_OPTIONS = new Map<
  string,
  OrderStatusFilterOption
>([
  [
    SamdStatusFilterValue.ALL_ORDERS,
    {
      label: 'All Orders',
      value: SamdStatusFilterValue.ALL_ORDERS,
    },
  ],
  [
    SamdStatusFilterValue.REPORT_READY,
    {
      label: 'Report Ready',
      value: SamdStatusFilterValue.REPORT_READY,
      statuses: [OrderStatus.ReportReady],
    },
  ],
  [
    SamdStatusFilterValue.PROCESSING,
    {
      label: 'Processing',
      value: SamdStatusFilterValue.PROCESSING,
      statuses: [OrderStatus.AiProcessing, OrderStatus.AiError],
    },
  ],
  [
    SamdStatusFilterValue.PENDING_ACTIONS,
    {
      label: 'Pending Actions',
      value: SamdStatusFilterValue.PENDING_ACTIONS,
      statuses: [OrderStatus.LabProcessing],
    },
  ],
  [
    SamdStatusFilterValue.DRAFTS,
    {
      label: 'Drafts',
      value: SamdStatusFilterValue.DRAFTS,
      statuses: [OrderStatus.Draft],
    },
  ],
]);
